export default __webpack_public_path__ + "static/media/svg-4.b2bb8de3.svg";